import { c as St, m as Ye } from "./metrics-api-Cn5wfR4o.mjs";
import { d as h, J as L, F as pe, i as be, E as Tt, j as Mt, k as Et, a as At, R as Se, p as xt, l as Ot, m as It, w as ye, O as Ct, b as Rt, q as Nt, s as Pt } from "./resources-DFDnbwuT.mjs";
var T;
(function(r) {
  r[r.INT = 0] = "INT", r[r.DOUBLE = 1] = "DOUBLE";
})(T || (T = {}));
var y;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE";
})(y || (y = {}));
var m;
(function(r) {
  r[r.HISTOGRAM = 0] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", r[r.GAUGE = 2] = "GAUGE", r[r.SUM = 3] = "SUM";
})(m || (m = {}));
var kt = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Te = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, Me = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, Lt = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Ut = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, Bt = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Gt(r) {
  return r != null;
}
function Je(r) {
  var e = Object.keys(r);
  return e.length === 0 ? "" : (e = e.sort(), JSON.stringify(e.map(function(t) {
    return [t, r[t]];
  })));
}
function Vt(r) {
  var e, t;
  return r.name + ":" + ((e = r.version) !== null && e !== void 0 ? e : "") + ":" + ((t = r.schemaUrl) !== null && t !== void 0 ? t : "");
}
var Ze = (
  /** @class */
  function(r) {
    kt(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return Object.setPrototypeOf(n, e.prototype), n;
    }
    return e;
  }(Error)
);
function N(r, e) {
  var t, n = new Promise(function(a, u) {
    t = setTimeout(function() {
      u(new Ze("Operation timed out."));
    }, e);
  });
  return Promise.race([r, n]).then(function(i) {
    return clearTimeout(t), i;
  }, function(i) {
    throw clearTimeout(t), i;
  });
}
function Ht(r) {
  return Te(this, void 0, void 0, function() {
    var e = this;
    return Me(this, function(t) {
      return [2, Promise.all(r.map(function(n) {
        return Te(e, void 0, void 0, function() {
          var i, a;
          return Me(this, function(u) {
            switch (u.label) {
              case 0:
                return u.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = u.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return a = u.sent(), [2, {
                  status: "rejected",
                  reason: a
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function Ft(r) {
  return r.status === "rejected";
}
function Ee(r, e) {
  var t = [];
  return r.forEach(function(n) {
    t.push.apply(t, Ut([], Lt(e(n)), !1));
  }), t;
}
function jt(r, e) {
  var t, n;
  if (r.size !== e.size)
    return !1;
  try {
    for (var i = Bt(r), a = i.next(); !a.done; a = i.next()) {
      var u = a.value;
      if (!e.has(u))
        return !1;
    }
  } catch (c) {
    t = { error: c };
  } finally {
    try {
      a && !a.done && (n = i.return) && n.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Dt(r, e) {
  for (var t = 0, n = r.length - 1, i = r.length; n >= t; ) {
    var a = t + Math.trunc((n - t) / 2);
    r[a] < e ? t = a + 1 : (i = a, n = a - 1);
  }
  return i;
}
function zt(r, e) {
  return r.toLowerCase() === e.toLowerCase();
}
var E;
(function(r) {
  r[r.DROP = 0] = "DROP", r[r.SUM = 1] = "SUM", r[r.LAST_VALUE = 2] = "LAST_VALUE", r[r.HISTOGRAM = 3] = "HISTOGRAM", r[r.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(E || (E = {}));
var $t = (
  /** @class */
  function() {
    function r() {
      this.kind = E.DROP;
    }
    return r.prototype.createAccumulation = function() {
    }, r.prototype.merge = function(e, t) {
    }, r.prototype.diff = function(e, t) {
    }, r.prototype.toMetricData = function(e, t, n, i) {
    }, r;
  }()
), d;
(function(r) {
  r.COUNTER = "COUNTER", r.GAUGE = "GAUGE", r.HISTOGRAM = "HISTOGRAM", r.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", r.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", r.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", r.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(d || (d = {}));
function S(r, e, t) {
  var n, i, a, u;
  return Yt(r) || h.warn('Invalid metric name: "' + r + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: r,
    type: e,
    description: (n = t == null ? void 0 : t.description) !== null && n !== void 0 ? n : "",
    unit: (i = t == null ? void 0 : t.unit) !== null && i !== void 0 ? i : "",
    valueType: (a = t == null ? void 0 : t.valueType) !== null && a !== void 0 ? a : T.DOUBLE,
    advice: (u = t == null ? void 0 : t.advice) !== null && u !== void 0 ? u : {}
  };
}
function Wt(r, e) {
  var t, n;
  return {
    name: (t = r.name) !== null && t !== void 0 ? t : e.name,
    description: (n = r.description) !== null && n !== void 0 ? n : e.description,
    type: e.type,
    unit: e.unit,
    valueType: e.valueType,
    advice: e.advice
  };
}
function Xt(r, e) {
  return zt(r.name, e.name) && r.unit === e.unit && r.type === e.type && r.valueType === e.valueType;
}
var qt = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function Yt(r) {
  return r.match(qt) != null;
}
var Jt = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
};
function Zt(r) {
  var e = r.map(function() {
    return 0;
  });
  return e.push(0), {
    buckets: {
      boundaries: r,
      counts: e
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var J = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = Zt(t)), this.startTime = e, this._boundaries = t, this._recordMinMax = n, this._current = i;
    }
    return r.prototype.record = function(e) {
      if (!Number.isNaN(e)) {
        this._current.count += 1, this._current.sum += e, this._recordMinMax && (this._current.min = Math.min(e, this._current.min), this._current.max = Math.max(e, this._current.max), this._current.hasMinMax = !0);
        var t = Dt(this._boundaries, e);
        this._current.buckets.counts[t] += 1;
      }
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), Qe = (
  /** @class */
  function() {
    function r(e, t) {
      this._boundaries = e, this._recordMinMax = t, this.kind = E.HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new J(e, this._boundaries, this._recordMinMax);
    }, r.prototype.merge = function(e, t) {
      for (var n = e.toPointValue(), i = t.toPointValue(), a = n.buckets.counts, u = i.buckets.counts, c = new Array(a.length), s = 0; s < a.length; s++)
        c[s] = a[s] + u[s];
      var o = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (o = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (o = n.min, l = n.max) : i.hasMinMax && (o = i.min, l = i.max)), new J(e.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: c
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: o,
        max: l
      });
    }, r.prototype.diff = function(e, t) {
      for (var n = e.toPointValue(), i = t.toPointValue(), a = n.buckets.counts, u = i.buckets.counts, c = new Array(a.length), s = 0; s < a.length; s++)
        c[s] = u[s] - a[s];
      return new J(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: c
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: m.HISTOGRAM,
        dataPoints: n.map(function(a) {
          var u = Jt(a, 2), c = u[0], s = u[1], o = s.toPointValue(), l = e.type === d.GAUGE || e.type === d.UP_DOWN_COUNTER || e.type === d.OBSERVABLE_GAUGE || e.type === d.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: c,
            startTime: s.startTime,
            endTime: i,
            value: {
              min: o.hasMinMax ? o.min : void 0,
              max: o.hasMinMax ? o.max : void 0,
              sum: l ? void 0 : o.sum,
              buckets: o.buckets,
              count: o.count
            }
          };
        })
      };
    }, r;
  }()
), Z = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Q = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, Ae = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      e === void 0 && (e = new Qt()), t === void 0 && (t = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = e, this.indexBase = t, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(r.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.counts = function() {
      var e = this;
      return Array.from({ length: this.length }, function(t, n) {
        return e.at(n);
      });
    }, r.prototype.at = function(e) {
      var t = this.indexBase - this.indexStart;
      return e < t && (e += this.backing.length), e -= t, this.backing.countAt(e);
    }, r.prototype.incrementBucket = function(e, t) {
      this.backing.increment(e, t);
    }, r.prototype.decrementBucket = function(e, t) {
      this.backing.decrement(e, t);
    }, r.prototype.trim = function() {
      for (var e = 0; e < this.length; e++)
        if (this.at(e) !== 0) {
          this.indexStart += e;
          break;
        } else if (e === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var e = this.length - 1; e >= 0; e--)
        if (this.at(e) !== 0) {
          this.indexEnd -= this.length - e - 1;
          break;
        }
      this._rotate();
    }, r.prototype.downscale = function(e) {
      this._rotate();
      for (var t = 1 + this.indexEnd - this.indexStart, n = 1 << e, i = 0, a = 0, u = this.indexStart; u <= this.indexEnd; ) {
        var c = u % n;
        c < 0 && (c += n);
        for (var s = c; s < n && i < t; s++)
          this._relocateBucket(a, i), i++, u++;
        a++;
      }
      this.indexStart >>= e, this.indexEnd >>= e, this.indexBase = this.indexStart;
    }, r.prototype.clone = function() {
      return new r(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, r.prototype._rotate = function() {
      var e = this.indexBase - this.indexStart;
      e !== 0 && (e > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, e), this.backing.reverse(e, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + e)), this.indexBase = this.indexStart);
    }, r.prototype._relocateBucket = function(e, t) {
      e !== t && this.incrementBucket(e, this.backing.emptyBucket(t));
    }, r;
  }()
), Qt = (
  /** @class */
  function() {
    function r(e) {
      e === void 0 && (e = [0]), this._counts = e;
    }
    return Object.defineProperty(r.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.countAt = function(e) {
      return this._counts[e];
    }, r.prototype.growTo = function(e, t, n) {
      var i = new Array(e).fill(0);
      i.splice.apply(i, Q([
        n,
        this._counts.length - t
      ], Z(this._counts.slice(t)), !1)), i.splice.apply(i, Q([0, t], Z(this._counts.slice(0, t)), !1)), this._counts = i;
    }, r.prototype.reverse = function(e, t) {
      for (var n = Math.floor((e + t) / 2) - e, i = 0; i < n; i++) {
        var a = this._counts[e + i];
        this._counts[e + i] = this._counts[t - i - 1], this._counts[t - i - 1] = a;
      }
    }, r.prototype.emptyBucket = function(e) {
      var t = this._counts[e];
      return this._counts[e] = 0, t;
    }, r.prototype.increment = function(e, t) {
      this._counts[e] += t;
    }, r.prototype.decrement = function(e, t) {
      this._counts[e] >= t ? this._counts[e] -= t : this._counts[e] = 0;
    }, r.prototype.clone = function() {
      return new r(Q([], Z(this._counts), !1));
    }, r;
  }()
), Kt = 52, er = 2146435072, tr = 1048575, Ke = 1023, et = -1022, tt = Ke, se = Math.pow(2, -1022);
function rt(r) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, r);
  var t = e.getUint32(0), n = (t & er) >> 20;
  return n - Ke;
}
function nt(r) {
  var e = new DataView(new ArrayBuffer(8));
  e.setFloat64(0, r);
  var t = e.getUint32(0), n = e.getUint32(4), i = (t & tr) * Math.pow(2, 32);
  return i + n;
}
function le(r, e) {
  return r === 0 || r === Number.POSITIVE_INFINITY || r === Number.NEGATIVE_INFINITY || Number.isNaN(r) ? r : r * Math.pow(2, e);
}
function rr(r) {
  return r--, r |= r >> 1, r |= r >> 2, r |= r >> 4, r |= r >> 8, r |= r >> 16, r++, r;
}
var nr = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), P = (
  /** @class */
  function(r) {
    nr(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(Error)
), ir = (
  /** @class */
  function() {
    function r(e) {
      this._shift = -e;
    }
    return r.prototype.mapToIndex = function(e) {
      if (e < se)
        return this._minNormalLowerBoundaryIndex();
      var t = rt(e), n = this._rightShift(nt(e) - 1, Kt);
      return t + n >> this._shift;
    }, r.prototype.lowerBoundary = function(e) {
      var t = this._minNormalLowerBoundaryIndex();
      if (e < t)
        throw new P("underflow: " + e + " is < minimum lower boundary: " + t);
      var n = this._maxNormalLowerBoundaryIndex();
      if (e > n)
        throw new P("overflow: " + e + " is > maximum lower boundary: " + n);
      return le(1, e << this._shift);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      var e = et >> this._shift;
      return this._shift < 2 && e--, e;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return tt >> this._shift;
    }, r.prototype._rightShift = function(e, t) {
      return Math.floor(e * Math.pow(2, -t));
    }, r;
  }()
), ar = (
  /** @class */
  function() {
    function r(e) {
      this._scale = e, this._scaleFactor = le(Math.LOG2E, e), this._inverseFactor = le(Math.LN2, -e);
    }
    return r.prototype.mapToIndex = function(e) {
      if (e <= se)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (nt(e) === 0) {
        var t = rt(e);
        return (t << this._scale) - 1;
      }
      var n = Math.floor(Math.log(e) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, r.prototype.lowerBoundary = function(e) {
      var t = this._maxNormalLowerBoundaryIndex();
      if (e >= t) {
        if (e === t)
          return 2 * Math.exp((e - (1 << this._scale)) / this._scaleFactor);
        throw new P("overflow: " + e + " is > maximum lower boundary: " + t);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (e <= n) {
        if (e === n)
          return se;
        if (e === n - 1)
          return Math.exp((e + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new P("overflow: " + e + " is < minimum lower boundary: " + n);
      }
      return Math.exp(e * this._inverseFactor);
    }, Object.defineProperty(r.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype._minNormalLowerBoundaryIndex = function() {
      return et << this._scale;
    }, r.prototype._maxNormalLowerBoundaryIndex = function() {
      return (tt + 1 << this._scale) - 1;
    }, r;
  }()
), xe = -10, Oe = 20, or = Array.from({ length: 31 }, function(r, e) {
  return e > 10 ? new ar(e - 10) : new ir(e - 10);
});
function Ie(r) {
  if (r > Oe || r < xe)
    throw new P("expected scale >= " + xe + " && <= " + Oe + ", got: " + r);
  return or[r + 10];
}
var ur = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, U = (
  /** @class */
  function() {
    function r(e, t) {
      this.low = e, this.high = t;
    }
    return r.combine = function(e, t) {
      return new r(Math.min(e.low, t.low), Math.max(e.high, t.high));
    }, r;
  }()
), cr = 20, sr = 160, K = 2, lr = (
  /** @class */
  function() {
    function r(e, t, n, i, a, u, c, s, o, l, f) {
      e === void 0 && (e = e), t === void 0 && (t = sr), n === void 0 && (n = !0), i === void 0 && (i = 0), a === void 0 && (a = 0), u === void 0 && (u = 0), c === void 0 && (c = Number.POSITIVE_INFINITY), s === void 0 && (s = Number.NEGATIVE_INFINITY), o === void 0 && (o = new Ae()), l === void 0 && (l = new Ae()), f === void 0 && (f = Ie(cr)), this.startTime = e, this._maxSize = t, this._recordMinMax = n, this._sum = i, this._count = a, this._zeroCount = u, this._min = c, this._max = s, this._positive = o, this._negative = l, this._mapping = f, this._maxSize < K && (h.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + K), this._maxSize = K);
    }
    return r.prototype.record = function(e) {
      this.updateByIncrement(e, 1);
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(r.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.updateByIncrement = function(e, t) {
      if (!Number.isNaN(e)) {
        if (e > this._max && (this._max = e), e < this._min && (this._min = e), this._count += t, e === 0) {
          this._zeroCount += t;
          return;
        }
        this._sum += e * t, e > 0 ? this._updateBuckets(this._positive, e, t) : this._updateBuckets(this._negative, -e, t);
      }
    }, r.prototype.merge = function(e) {
      this._count === 0 ? (this._min = e.min, this._max = e.max) : e.count !== 0 && (e.min < this.min && (this._min = e.min), e.max > this.max && (this._max = e.max)), this.startTime = e.startTime, this._sum += e.sum, this._count += e.count, this._zeroCount += e.zeroCount;
      var t = this._minScale(e);
      this._downscale(this.scale - t), this._mergeBuckets(this.positive, e, e.positive, t), this._mergeBuckets(this.negative, e, e.negative, t);
    }, r.prototype.diff = function(e) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= e.sum, this._count -= e.count, this._zeroCount -= e.zeroCount;
      var t = this._minScale(e);
      this._downscale(this.scale - t), this._diffBuckets(this.positive, e, e.positive, t), this._diffBuckets(this.negative, e, e.negative, t);
    }, r.prototype.clone = function() {
      return new r(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, r.prototype._updateBuckets = function(e, t, n) {
      var i = this._mapping.mapToIndex(t), a = !1, u = 0, c = 0;
      if (e.length === 0 ? (e.indexStart = i, e.indexEnd = e.indexStart, e.indexBase = e.indexStart) : i < e.indexStart && e.indexEnd - i >= this._maxSize ? (a = !0, c = i, u = e.indexEnd) : i > e.indexEnd && i - e.indexStart >= this._maxSize && (a = !0, c = e.indexStart, u = i), a) {
        var s = this._changeScale(u, c);
        this._downscale(s), i = this._mapping.mapToIndex(t);
      }
      this._incrementIndexBy(e, i, n);
    }, r.prototype._incrementIndexBy = function(e, t, n) {
      if (n !== 0) {
        if (e.length === 0 && (e.indexStart = e.indexEnd = e.indexBase = t), t < e.indexStart) {
          var i = e.indexEnd - t;
          i >= e.backing.length && this._grow(e, i + 1), e.indexStart = t;
        } else if (t > e.indexEnd) {
          var i = t - e.indexStart;
          i >= e.backing.length && this._grow(e, i + 1), e.indexEnd = t;
        }
        var a = t - e.indexBase;
        a < 0 && (a += e.backing.length), e.incrementBucket(a, n);
      }
    }, r.prototype._grow = function(e, t) {
      var n = e.backing.length, i = e.indexBase - e.indexStart, a = n - i, u = rr(t);
      u > this._maxSize && (u = this._maxSize);
      var c = u - i;
      e.backing.growTo(u, a, c);
    }, r.prototype._changeScale = function(e, t) {
      for (var n = 0; e - t >= this._maxSize; )
        e >>= 1, t >>= 1, n++;
      return n;
    }, r.prototype._downscale = function(e) {
      if (e !== 0) {
        if (e < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var t = this._mapping.scale - e;
        this._positive.downscale(e), this._negative.downscale(e), this._mapping = Ie(t);
      }
    }, r.prototype._minScale = function(e) {
      var t = Math.min(this.scale, e.scale), n = U.combine(this._highLowAtScale(this.positive, this.scale, t), this._highLowAtScale(e.positive, e.scale, t)), i = U.combine(this._highLowAtScale(this.negative, this.scale, t), this._highLowAtScale(e.negative, e.scale, t));
      return Math.min(t - this._changeScale(n.high, n.low), t - this._changeScale(i.high, i.low));
    }, r.prototype._highLowAtScale = function(e, t, n) {
      if (e.length === 0)
        return new U(0, -1);
      var i = t - n;
      return new U(e.indexStart >> i, e.indexEnd >> i);
    }, r.prototype._mergeBuckets = function(e, t, n, i) {
      for (var a = n.offset, u = t.scale - i, c = 0; c < n.length; c++)
        this._incrementIndexBy(e, a + c >> u, n.at(c));
    }, r.prototype._diffBuckets = function(e, t, n, i) {
      for (var a = n.offset, u = t.scale - i, c = 0; c < n.length; c++) {
        var s = a + c >> u, o = s - e.indexBase;
        o < 0 && (o += e.backing.length), e.decrementBucket(o, n.at(c));
      }
      e.trim();
    }, r;
  }()
), fr = (
  /** @class */
  function() {
    function r(e, t) {
      this._maxSize = e, this._recordMinMax = t, this.kind = E.EXPONENTIAL_HISTOGRAM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new lr(e, this._maxSize, this._recordMinMax);
    }, r.prototype.merge = function(e, t) {
      var n = t.clone();
      return n.merge(e), n;
    }, r.prototype.diff = function(e, t) {
      var n = t.clone();
      return n.diff(e), n;
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: m.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(a) {
          var u = ur(a, 2), c = u[0], s = u[1], o = s.toPointValue(), l = e.type === d.GAUGE || e.type === d.UP_DOWN_COUNTER || e.type === d.OBSERVABLE_GAUGE || e.type === d.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: c,
            startTime: s.startTime,
            endTime: i,
            value: {
              min: o.hasMinMax ? o.min : void 0,
              max: o.hasMinMax ? o.max : void 0,
              sum: l ? void 0 : o.sum,
              positive: {
                offset: o.positive.offset,
                bucketCounts: o.positive.bucketCounts
              },
              negative: {
                offset: o.negative.offset,
                bucketCounts: o.negative.bucketCounts
              },
              count: o.count,
              scale: o.scale,
              zeroCount: o.zeroCount
            }
          };
        })
      };
    }, r;
  }()
), dr = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, ee = (
  /** @class */
  function() {
    function r(e, t, n) {
      t === void 0 && (t = 0), n === void 0 && (n = [0, 0]), this.startTime = e, this._current = t, this.sampleTime = n;
    }
    return r.prototype.record = function(e) {
      this._current = e, this.sampleTime = pe(Date.now());
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), hr = (
  /** @class */
  function() {
    function r() {
      this.kind = E.LAST_VALUE;
    }
    return r.prototype.createAccumulation = function(e) {
      return new ee(e);
    }, r.prototype.merge = function(e, t) {
      var n = L(t.sampleTime) >= L(e.sampleTime) ? t : e;
      return new ee(e.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.diff = function(e, t) {
      var n = L(t.sampleTime) >= L(e.sampleTime) ? t : e;
      return new ee(t.startTime, n.toPointValue(), n.sampleTime);
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: m.GAUGE,
        dataPoints: n.map(function(a) {
          var u = dr(a, 2), c = u[0], s = u[1];
          return {
            attributes: c,
            startTime: s.startTime,
            endTime: i,
            value: s.toPointValue()
          };
        })
      };
    }, r;
  }()
), pr = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, C = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = e, this.monotonic = t, this._current = n, this.reset = i;
    }
    return r.prototype.record = function(e) {
      this.monotonic && e < 0 || (this._current += e);
    }, r.prototype.setStartTime = function(e) {
      this.startTime = e;
    }, r.prototype.toPointValue = function() {
      return this._current;
    }, r;
  }()
), Ce = (
  /** @class */
  function() {
    function r(e) {
      this.monotonic = e, this.kind = E.SUM;
    }
    return r.prototype.createAccumulation = function(e) {
      return new C(e, this.monotonic);
    }, r.prototype.merge = function(e, t) {
      var n = e.toPointValue(), i = t.toPointValue();
      return t.reset ? new C(t.startTime, this.monotonic, i, t.reset) : new C(e.startTime, this.monotonic, n + i);
    }, r.prototype.diff = function(e, t) {
      var n = e.toPointValue(), i = t.toPointValue();
      return this.monotonic && n > i ? new C(t.startTime, this.monotonic, i, !0) : new C(t.startTime, this.monotonic, i - n);
    }, r.prototype.toMetricData = function(e, t, n, i) {
      return {
        descriptor: e,
        aggregationTemporality: t,
        dataPointType: m.SUM,
        dataPoints: n.map(function(a) {
          var u = pr(a, 2), c = u[0], s = u[1];
          return {
            attributes: c,
            startTime: s.startTime,
            endTime: i,
            value: s.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, r;
  }()
), A = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), b = (
  /** @class */
  function() {
    function r() {
    }
    return r.Drop = function() {
      return it;
    }, r.Sum = function() {
      return at;
    }, r.LastValue = function() {
      return ot;
    }, r.Histogram = function() {
      return ut;
    }, r.ExponentialHistogram = function() {
      return Sr;
    }, r.Default = function() {
      return Tr;
    }, r;
  }()
), yr = (
  /** @class */
  function(r) {
    A(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new $t(), e;
  }(b)
), vr = (
  /** @class */
  function(r) {
    A(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      switch (t.type) {
        case d.COUNTER:
        case d.OBSERVABLE_COUNTER:
        case d.HISTOGRAM:
          return e.MONOTONIC_INSTANCE;
        default:
          return e.NON_MONOTONIC_INSTANCE;
      }
    }, e.MONOTONIC_INSTANCE = new Ce(!0), e.NON_MONOTONIC_INSTANCE = new Ce(!1), e;
  }(b)
), mr = (
  /** @class */
  function(r) {
    A(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new hr(), e;
  }(b)
), _r = (
  /** @class */
  function(r) {
    A(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.createAggregator = function(t) {
      return e.DEFAULT_INSTANCE;
    }, e.DEFAULT_INSTANCE = new Qe([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), e;
  }(b)
), gr = (
  /** @class */
  function(r) {
    A(e, r);
    function e(t, n) {
      n === void 0 && (n = !0);
      var i = r.call(this) || this;
      if (i._recordMinMax = n, t == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      t = t.concat(), t = t.sort(function(c, s) {
        return c - s;
      });
      var a = t.lastIndexOf(-1 / 0), u = t.indexOf(1 / 0);
      return u === -1 && (u = void 0), i._boundaries = t.slice(a + 1, u), i;
    }
    return e.prototype.createAggregator = function(t) {
      return new Qe(this._boundaries, this._recordMinMax);
    }, e;
  }(b)
), wr = (
  /** @class */
  function(r) {
    A(e, r);
    function e(t, n) {
      t === void 0 && (t = 160), n === void 0 && (n = !0);
      var i = r.call(this) || this;
      return i._maxSize = t, i._recordMinMax = n, i;
    }
    return e.prototype.createAggregator = function(t) {
      return new fr(this._maxSize, this._recordMinMax);
    }, e;
  }(b)
), br = (
  /** @class */
  function(r) {
    A(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype._resolve = function(t) {
      switch (t.type) {
        case d.COUNTER:
        case d.UP_DOWN_COUNTER:
        case d.OBSERVABLE_COUNTER:
        case d.OBSERVABLE_UP_DOWN_COUNTER:
          return at;
        case d.GAUGE:
        case d.OBSERVABLE_GAUGE:
          return ot;
        case d.HISTOGRAM:
          return t.advice.explicitBucketBoundaries ? new gr(t.advice.explicitBucketBoundaries) : ut;
      }
      return h.warn("Unable to recognize instrument type: " + t.type), it;
    }, e.prototype.createAggregator = function(t) {
      return this._resolve(t).createAggregator(t);
    }, e;
  }(b)
), it = new yr(), at = new vr(), ot = new mr(), ut = new _r(), Sr = new wr(), Tr = new br(), Mr = function(r) {
  return b.Default();
}, Er = function(r) {
  return y.CUMULATIVE;
}, te = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, re = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, Re = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Ar = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, xr = (
  /** @class */
  function() {
    function r(e) {
      var t, n, i;
      this._shutdown = !1, this._aggregationSelector = (t = e == null ? void 0 : e.aggregationSelector) !== null && t !== void 0 ? t : Mr, this._aggregationTemporalitySelector = (n = e == null ? void 0 : e.aggregationTemporalitySelector) !== null && n !== void 0 ? n : Er, this._metricProducers = (i = e == null ? void 0 : e.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = e == null ? void 0 : e.cardinalitySelector;
    }
    return r.prototype.setMetricProducer = function(e) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = e, this.onInitialized();
    }, r.prototype.selectAggregation = function(e) {
      return this._aggregationSelector(e);
    }, r.prototype.selectAggregationTemporality = function(e) {
      return this._aggregationTemporalitySelector(e);
    }, r.prototype.selectCardinalityLimit = function(e) {
      return this._cardinalitySelector ? this._cardinalitySelector(e) : 2e3;
    }, r.prototype.onInitialized = function() {
    }, r.prototype.collect = function(e) {
      return te(this, void 0, void 0, function() {
        var t, n, i, a, u, c;
        return re(this, function(s) {
          switch (s.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(Ar([
                this._sdkMetricProducer.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                })
              ], Re(this._metricProducers.map(function(o) {
                return o.collect({
                  timeoutMillis: e == null ? void 0 : e.timeoutMillis
                });
              })), !1))];
            case 1:
              return t = Re.apply(void 0, [s.sent()]), n = t[0], i = t.slice(1), a = n.errors.concat(Ee(i, function(o) {
                return o.errors;
              })), u = n.resourceMetrics.resource, c = n.resourceMetrics.scopeMetrics.concat(Ee(i, function(o) {
                return o.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: u,
                  scopeMetrics: c
                },
                errors: a
              }];
          }
        });
      });
    }, r.prototype.shutdown = function(e) {
      return te(this, void 0, void 0, function() {
        return re(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (h.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return t.sent(), [3, 4];
            case 2:
              return [4, N(this.onShutdown(), e.timeoutMillis)];
            case 3:
              t.sent(), t.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return te(this, void 0, void 0, function() {
        return re(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (h.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : (e == null ? void 0 : e.timeoutMillis) != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, N(this.onForceFlush(), e.timeoutMillis)];
            case 3:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
), Or = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), B = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, G = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, Ir = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Cr = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, Rr = (
  /** @class */
  function(r) {
    Or(e, r);
    function e(t) {
      var n, i, a, u, c = r.call(this, {
        aggregationSelector: (n = t.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(t.exporter),
        aggregationTemporalitySelector: (i = t.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(t.exporter),
        metricProducers: t.metricProducers
      }) || this;
      if (t.exportIntervalMillis !== void 0 && t.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (t.exportTimeoutMillis !== void 0 && t.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (t.exportTimeoutMillis !== void 0 && t.exportIntervalMillis !== void 0 && t.exportIntervalMillis < t.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return c._exportInterval = (a = t.exportIntervalMillis) !== null && a !== void 0 ? a : 6e4, c._exportTimeout = (u = t.exportTimeoutMillis) !== null && u !== void 0 ? u : 3e4, c._exporter = t.exporter, c;
    }
    return e.prototype._runOnce = function() {
      return B(this, void 0, void 0, function() {
        var t;
        return G(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, N(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return t = n.sent(), t instanceof Ze ? (h.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (be(t), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype._doRun = function() {
      var t, n;
      return B(this, void 0, void 0, function() {
        var i, a, u, c, s, o;
        return G(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), a = i.resourceMetrics, u = i.errors, u.length > 0 && (o = h).error.apply(o, Cr(["PeriodicExportingMetricReader: metrics collection errors"], Ir(u), !1)), !a.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (t = a.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(t)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return c = l.sent(), h.debug("Error while resolving async portion of resource: ", c), be(c), [3, 5];
            case 5:
              return a.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, Mt._export(this._exporter, a)];
            case 6:
              if (s = l.sent(), s.code !== Tt.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + s.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onInitialized = function() {
      var t = this;
      this._interval = setInterval(function() {
        t._runOnce();
      }, this._exportInterval), Et(this._interval);
    }, e.prototype.onForceFlush = function() {
      return B(this, void 0, void 0, function() {
        return G(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return t.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.onShutdown = function() {
      return B(this, void 0, void 0, function() {
        return G(this, function(t) {
          switch (t.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return t.sent(), [4, this._exporter.shutdown()];
            case 2:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }(xr)
), Nr = (
  /** @class */
  function() {
    function r() {
      this._registeredViews = [];
    }
    return r.prototype.addView = function(e) {
      this._registeredViews.push(e);
    }, r.prototype.findViews = function(e, t) {
      var n = this, i = this._registeredViews.filter(function(a) {
        return n._matchInstrument(a.instrumentSelector, e) && n._matchMeter(a.meterSelector, t);
      });
      return i;
    }, r.prototype._matchInstrument = function(e, t) {
      return (e.getType() === void 0 || t.type === e.getType()) && e.getNameFilter().match(t.name) && e.getUnitFilter().match(t.unit);
    }, r.prototype._matchMeter = function(e, t) {
      return e.getNameFilter().match(t.name) && (t.version === void 0 || e.getVersionFilter().match(t.version)) && (t.schemaUrl === void 0 || e.getSchemaUrlFilter().match(t.schemaUrl));
    }, r;
  }()
), x = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), $ = (
  /** @class */
  function() {
    function r(e, t) {
      this._writableMetricStorage = e, this._descriptor = t;
    }
    return r.prototype._record = function(e, t, n) {
      if (t === void 0 && (t = {}), n === void 0 && (n = At.active()), typeof e != "number") {
        h.warn("non-number value provided to metric " + this._descriptor.name + ": " + e);
        return;
      }
      this._descriptor.valueType === T.INT && !Number.isInteger(e) && (h.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._writableMetricStorage.record(e, t, n, pe(Date.now()));
    }, r;
  }()
), Pr = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n, i) {
      this._record(t, n, i);
    }, e;
  }($)
), kr = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.add = function(t, n, i) {
      if (t < 0) {
        h.warn("negative value provided to counter " + this._descriptor.name + ": " + t);
        return;
      }
      this._record(t, n, i);
    }, e;
  }($)
), Lr = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n, i) {
      this._record(t, n, i);
    }, e;
  }($)
), Ur = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.record = function(t, n, i) {
      if (t < 0) {
        h.warn("negative value provided to histogram " + this._descriptor.name + ": " + t);
        return;
      }
      this._record(t, n, i);
    }, e;
  }($)
), W = (
  /** @class */
  function() {
    function r(e, t, n) {
      this._observableRegistry = n, this._descriptor = e, this._metricStorages = t;
    }
    return r.prototype.addCallback = function(e) {
      this._observableRegistry.addCallback(e, this);
    }, r.prototype.removeCallback = function(e) {
      this._observableRegistry.removeCallback(e, this);
    }, r;
  }()
), Br = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(W)
), Gr = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(W)
), Vr = (
  /** @class */
  function(r) {
    x(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e;
  }(W)
);
function fe(r) {
  return r instanceof W;
}
var Hr = (
  /** @class */
  function() {
    function r(e) {
      this._meterSharedState = e;
    }
    return r.prototype.createGauge = function(e, t) {
      var n = S(e, d.GAUGE, t), i = this._meterSharedState.registerMetricStorage(n);
      return new Lr(i, n);
    }, r.prototype.createHistogram = function(e, t) {
      var n = S(e, d.HISTOGRAM, t), i = this._meterSharedState.registerMetricStorage(n);
      return new Ur(i, n);
    }, r.prototype.createCounter = function(e, t) {
      var n = S(e, d.COUNTER, t), i = this._meterSharedState.registerMetricStorage(n);
      return new kr(i, n);
    }, r.prototype.createUpDownCounter = function(e, t) {
      var n = S(e, d.UP_DOWN_COUNTER, t), i = this._meterSharedState.registerMetricStorage(n);
      return new Pr(i, n);
    }, r.prototype.createObservableGauge = function(e, t) {
      var n = S(e, d.OBSERVABLE_GAUGE, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Gr(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableCounter = function(e, t) {
      var n = S(e, d.OBSERVABLE_COUNTER, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Br(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.createObservableUpDownCounter = function(e, t) {
      var n = S(e, d.OBSERVABLE_UP_DOWN_COUNTER, t), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new Vr(n, i, this._meterSharedState.observableRegistry);
    }, r.prototype.addBatchObservableCallback = function(e, t) {
      this._meterSharedState.observableRegistry.addBatchCallback(e, t);
    }, r.prototype.removeBatchObservableCallback = function(e, t) {
      this._meterSharedState.observableRegistry.removeBatchCallback(e, t);
    }, r;
  }()
), ct = (
  /** @class */
  function() {
    function r(e) {
      this._instrumentDescriptor = e;
    }
    return r.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, r.prototype.updateDescription = function(e) {
      this._instrumentDescriptor = S(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: e,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, r;
  }()
), Fr = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ne = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, jr = (
  /** @class */
  function() {
    function r(e) {
      this._hash = e, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return r.prototype.get = function(e, t) {
      return t ?? (t = this._hash(e)), this._valueMap.get(t);
    }, r.prototype.getOrDefault = function(e, t) {
      var n = this._hash(e);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = t();
      return this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, i), i;
    }, r.prototype.set = function(e, t, n) {
      n ?? (n = this._hash(e)), this._keyMap.has(n) || this._keyMap.set(n, e), this._valueMap.set(n, t);
    }, r.prototype.has = function(e, t) {
      return t ?? (t = this._hash(e)), this._valueMap.has(t);
    }, r.prototype.keys = function() {
      var e, t;
      return Ne(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._keyMap.entries(), t = e.next(), n.label = 1;
          case 1:
            return t.done === !0 ? [3, 3] : [4, [t.value[1], t.value[0]]];
          case 2:
            return n.sent(), t = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, r.prototype.entries = function() {
      var e, t;
      return Ne(this, function(n) {
        switch (n.label) {
          case 0:
            e = this._valueMap.entries(), t = e.next(), n.label = 1;
          case 1:
            return t.done === !0 ? [3, 3] : [4, [this._keyMap.get(t.value[0]), t.value[1], t.value[0]]];
          case 2:
            return n.sent(), t = e.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(r.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }()
), M = (
  /** @class */
  function(r) {
    Fr(e, r);
    function e() {
      return r.call(this, Je) || this;
    }
    return e;
  }(jr)
), Dr = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, st = (
  /** @class */
  function() {
    function r(e, t) {
      this._aggregator = e, this._activeCollectionStorage = new M(), this._cumulativeMemoStorage = new M(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (t ?? 2e3) - 1, this._overflowHashCode = Je(this._overflowAttributes);
    }
    return r.prototype.record = function(e, t, n, i) {
      var a = this, u = this._activeCollectionStorage.get(t);
      if (!u) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var c = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return a._aggregator.createAccumulation(i);
          });
          c == null || c.record(e);
          return;
        }
        u = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(t, u);
      }
      u == null || u.record(e);
    }, r.prototype.batchCumulate = function(e, t) {
      var n = this;
      Array.from(e.entries()).forEach(function(i) {
        var a = Dr(i, 3), u = a[0], c = a[1], s = a[2], o = n._aggregator.createAccumulation(t);
        o == null || o.record(c);
        var l = o;
        if (n._cumulativeMemoStorage.has(u, s)) {
          var f = n._cumulativeMemoStorage.get(u, s);
          l = n._aggregator.diff(f, o);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (u = n._overflowAttributes, s = n._overflowHashCode, n._cumulativeMemoStorage.has(u, s))) {
          var f = n._cumulativeMemoStorage.get(u, s);
          l = n._aggregator.diff(f, o);
        }
        if (n._activeCollectionStorage.has(u, s)) {
          var p = n._activeCollectionStorage.get(u, s);
          l = n._aggregator.merge(p, l);
        }
        n._cumulativeMemoStorage.set(u, o, s), n._activeCollectionStorage.set(u, l, s);
      });
    }, r.prototype.collect = function() {
      var e = this._activeCollectionStorage;
      return this._activeCollectionStorage = new M(), e;
    }, r;
  }()
), ne = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Pe = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, lt = (
  /** @class */
  function() {
    function r(e, t) {
      var n = this;
      this._aggregator = e, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), t.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return r.prototype.buildMetrics = function(e, t, n, i) {
      this._stashAccumulations(n);
      var a = this._getMergedUnreportedAccumulations(e), u = a, c;
      if (this._reportHistory.has(e)) {
        var s = this._reportHistory.get(e), o = s.collectionTime;
        c = s.aggregationTemporality, c === y.CUMULATIVE ? u = r.merge(s.accumulations, a, this._aggregator) : u = r.calibrateStartTime(s.accumulations, a, o);
      } else
        c = e.selectAggregationTemporality(t.type);
      this._reportHistory.set(e, {
        accumulations: u,
        collectionTime: i,
        aggregationTemporality: c
      });
      var l = zr(u);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          t,
          c,
          l,
          /* endTime */
          i
        );
    }, r.prototype._stashAccumulations = function(e) {
      var t, n, i = this._unreportedAccumulations.keys();
      try {
        for (var a = ne(i), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = this._unreportedAccumulations.get(c);
          s === void 0 && (s = [], this._unreportedAccumulations.set(c, s)), s.push(e);
        }
      } catch (o) {
        t = { error: o };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
    }, r.prototype._getMergedUnreportedAccumulations = function(e) {
      var t, n, i = new M(), a = this._unreportedAccumulations.get(e);
      if (this._unreportedAccumulations.set(e, []), a === void 0)
        return i;
      try {
        for (var u = ne(a), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          i = r.merge(i, s, this._aggregator);
        }
      } catch (o) {
        t = { error: o };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (t) throw t.error;
        }
      }
      return i;
    }, r.merge = function(e, t, n) {
      for (var i = e, a = t.entries(), u = a.next(); u.done !== !0; ) {
        var c = Pe(u.value, 3), s = c[0], o = c[1], l = c[2];
        if (e.has(s, l)) {
          var f = e.get(s, l), p = n.merge(f, o);
          i.set(s, p, l);
        } else
          i.set(s, o, l);
        u = a.next();
      }
      return i;
    }, r.calibrateStartTime = function(e, t, n) {
      var i, a;
      try {
        for (var u = ne(e.keys()), c = u.next(); !c.done; c = u.next()) {
          var s = Pe(c.value, 2), o = s[0], l = s[1], f = t.get(o, l);
          f == null || f.setStartTime(n);
        }
      } catch (p) {
        i = { error: p };
      } finally {
        try {
          c && !c.done && (a = u.return) && a.call(u);
        } finally {
          if (i) throw i.error;
        }
      }
      return t;
    }, r;
  }()
);
function zr(r) {
  return Array.from(r.entries());
}
var $r = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Wr = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Xr = (
  /** @class */
  function(r) {
    $r(e, r);
    function e(t, n, i, a, u) {
      var c = r.call(this, t) || this;
      return c._attributesProcessor = i, c._aggregationCardinalityLimit = u, c._deltaMetricStorage = new st(n, c._aggregationCardinalityLimit), c._temporalMetricStorage = new lt(n, a), c;
    }
    return e.prototype.record = function(t, n) {
      var i = this, a = new M();
      Array.from(t.entries()).forEach(function(u) {
        var c = Wr(u, 2), s = c[0], o = c[1];
        a.set(i._attributesProcessor.process(s), o);
      }), this._deltaMetricStorage.batchCumulate(a, n);
    }, e.prototype.collect = function(t, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(t, this._instrumentDescriptor, i, n);
    }, e;
  }(ct)
);
function ke(r, e) {
  var t = "";
  return r.unit !== e.unit && (t += "	- Unit '" + r.unit + "' does not match '" + e.unit + `'
`), r.type !== e.type && (t += "	- Type '" + r.type + "' does not match '" + e.type + `'
`), r.valueType !== e.valueType && (t += "	- Value Type '" + r.valueType + "' does not match '" + e.valueType + `'
`), r.description !== e.description && (t += "	- Description '" + r.description + "' does not match '" + e.description + `'
`), t;
}
function qr(r, e) {
  return "	- use valueType '" + r.valueType + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function Yr(r, e) {
  return "	- use unit '" + r.unit + "' on instrument creation or use an instrument name other than '" + e.name + "'";
}
function Jr(r, e) {
  var t = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(t);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + "'";
}
function Zr(r, e) {
  var t = {
    name: e.name,
    type: e.type,
    unit: e.unit
  }, n = JSON.stringify(t);
  return "	- create a new view with a name other than '" + r.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + r.name + " and description '" + r.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + e.name + " and description '" + r.description + "' and InstrumentSelector " + n;
}
function Le(r, e) {
  return r.valueType !== e.valueType ? qr(r, e) : r.unit !== e.unit ? Yr(r, e) : r.type !== e.type ? Jr(r, e) : r.description !== e.description ? Zr(r, e) : "";
}
var ie = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Qr = (
  /** @class */
  function() {
    function r() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return r.create = function() {
      return new r();
    }, r.prototype.getStorages = function(e) {
      var t, n, i, a, u = [];
      try {
        for (var c = ie(this._sharedRegistry.values()), s = c.next(); !s.done; s = c.next()) {
          var o = s.value;
          u = u.concat(o);
        }
      } catch (w) {
        t = { error: w };
      } finally {
        try {
          s && !s.done && (n = c.return) && n.call(c);
        } finally {
          if (t) throw t.error;
        }
      }
      var l = this._perCollectorRegistry.get(e);
      if (l != null)
        try {
          for (var f = ie(l.values()), p = f.next(); !p.done; p = f.next()) {
            var o = p.value;
            u = u.concat(o);
          }
        } catch (w) {
          i = { error: w };
        } finally {
          try {
            p && !p.done && (a = f.return) && a.call(f);
          } finally {
            if (i) throw i.error;
          }
        }
      return u;
    }, r.prototype.register = function(e) {
      this._registerStorage(e, this._sharedRegistry);
    }, r.prototype.registerForCollector = function(e, t) {
      var n = this._perCollectorRegistry.get(e);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(e, n)), this._registerStorage(t, n);
    }, r.prototype.findOrUpdateCompatibleStorage = function(e) {
      var t = this._sharedRegistry.get(e.name);
      return t === void 0 ? null : this._findOrUpdateCompatibleStorage(e, t);
    }, r.prototype.findOrUpdateCompatibleCollectorStorage = function(e, t) {
      var n = this._perCollectorRegistry.get(e);
      if (n === void 0)
        return null;
      var i = n.get(t.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(t, i);
    }, r.prototype._registerStorage = function(e, t) {
      var n = e.getInstrumentDescriptor(), i = t.get(n.name);
      if (i === void 0) {
        t.set(n.name, [e]);
        return;
      }
      i.push(e);
    }, r.prototype._findOrUpdateCompatibleStorage = function(e, t) {
      var n, i, a = null;
      try {
        for (var u = ie(t), c = u.next(); !c.done; c = u.next()) {
          var s = c.value, o = s.getInstrumentDescriptor();
          Xt(o, e) ? (o.description !== e.description && (e.description.length > o.description.length && s.updateDescription(e.description), h.warn("A view or instrument with the name ", e.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, ke(o, e), `The longer description will be used.
To resolve the conflict:`, Le(o, e))), a = s) : h.warn("A view or instrument with the name ", e.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, ke(o, e), `To resolve the conflict:
`, Le(o, e));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          c && !c.done && (i = u.return) && i.call(u);
        } finally {
          if (n) throw n.error;
        }
      }
      return a;
    }, r;
  }()
), Kr = (
  /** @class */
  function() {
    function r(e) {
      this._backingStorages = e;
    }
    return r.prototype.record = function(e, t, n, i) {
      this._backingStorages.forEach(function(a) {
        a.record(e, t, n, i);
      });
    }, r;
  }()
), en = (
  /** @class */
  function() {
    function r(e, t) {
      this._instrumentName = e, this._valueType = t, this._buffer = new M();
    }
    return r.prototype.observe = function(e, t) {
      if (t === void 0 && (t = {}), typeof e != "number") {
        h.warn("non-number value provided to metric " + this._instrumentName + ": " + e);
        return;
      }
      this._valueType === T.INT && !Number.isInteger(e) && (h.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), e = Math.trunc(e), !Number.isInteger(e)) || this._buffer.set(t, e);
    }, r;
  }()
), tn = (
  /** @class */
  function() {
    function r() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return r.prototype.observe = function(e, t, n) {
      if (n === void 0 && (n = {}), !!fe(e)) {
        var i = this._buffer.get(e);
        if (i == null && (i = new M(), this._buffer.set(e, i)), typeof t != "number") {
          h.warn("non-number value provided to metric " + e._descriptor.name + ": " + t);
          return;
        }
        e._descriptor.valueType === T.INT && !Number.isInteger(t) && (h.warn("INT value type cannot accept a floating-point value for " + e._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || i.set(n, t);
      }
    }, r;
  }()
), ae = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, oe = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, Ue = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, Be = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, rn = (
  /** @class */
  function() {
    function r() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return r.prototype.addCallback = function(e, t) {
      var n = this._findCallback(e, t);
      n >= 0 || this._callbacks.push({ callback: e, instrument: t });
    }, r.prototype.removeCallback = function(e, t) {
      var n = this._findCallback(e, t);
      n < 0 || this._callbacks.splice(n, 1);
    }, r.prototype.addBatchCallback = function(e, t) {
      var n = new Set(t.filter(fe));
      if (n.size === 0) {
        h.error("BatchObservableCallback is not associated with valid instruments", t);
        return;
      }
      var i = this._findBatchCallback(e, n);
      i >= 0 || this._batchCallbacks.push({ callback: e, instruments: n });
    }, r.prototype.removeBatchCallback = function(e, t) {
      var n = new Set(t.filter(fe)), i = this._findBatchCallback(e, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, r.prototype.observe = function(e, t) {
      return ae(this, void 0, void 0, function() {
        var n, i, a, u;
        return oe(this, function(c) {
          switch (c.label) {
            case 0:
              return n = this._observeCallbacks(e, t), i = this._observeBatchCallbacks(e, t), [4, Ht(Be(Be([], Ue(n), !1), Ue(i), !1))];
            case 1:
              return a = c.sent(), u = a.filter(Ft).map(function(s) {
                return s.reason;
              }), [2, u];
          }
        });
      });
    }, r.prototype._observeCallbacks = function(e, t) {
      var n = this;
      return this._callbacks.map(function(i) {
        var a = i.callback, u = i.instrument;
        return ae(n, void 0, void 0, function() {
          var c, s;
          return oe(this, function(o) {
            switch (o.label) {
              case 0:
                return c = new en(u._descriptor.name, u._descriptor.valueType), s = Promise.resolve(a(c)), t != null && (s = N(s, t)), [4, s];
              case 1:
                return o.sent(), u._metricStorages.forEach(function(l) {
                  l.record(c._buffer, e);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._observeBatchCallbacks = function(e, t) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var a = i.callback, u = i.instruments;
        return ae(n, void 0, void 0, function() {
          var c, s;
          return oe(this, function(o) {
            switch (o.label) {
              case 0:
                return c = new tn(), s = Promise.resolve(a(c)), t != null && (s = N(s, t)), [4, s];
              case 1:
                return o.sent(), u.forEach(function(l) {
                  var f = c._buffer.get(l);
                  f != null && l._metricStorages.forEach(function(p) {
                    p.record(f, e);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, r.prototype._findCallback = function(e, t) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === e && n.instrument === t;
      });
    }, r.prototype._findBatchCallback = function(e, t) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === e && jt(n.instruments, t);
      });
    }, r;
  }()
), nn = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), an = (
  /** @class */
  function(r) {
    nn(e, r);
    function e(t, n, i, a, u) {
      var c = r.call(this, t) || this;
      return c._attributesProcessor = i, c._aggregationCardinalityLimit = u, c._deltaMetricStorage = new st(n, c._aggregationCardinalityLimit), c._temporalMetricStorage = new lt(n, a), c;
    }
    return e.prototype.record = function(t, n, i, a) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(t, n, i, a);
    }, e.prototype.collect = function(t, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(t, this._instrumentDescriptor, i, n);
    }, e;
  }(ct)
), ft = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ve = (
  /** @class */
  function() {
    function r() {
    }
    return r.Noop = function() {
      return un;
    }, r;
  }()
), on = (
  /** @class */
  function(r) {
    ft(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.process = function(t, n) {
      return t;
    }, e;
  }(ve)
);
(function(r) {
  ft(e, r);
  function e(t) {
    var n = r.call(this) || this;
    return n._allowedAttributeNames = t, n;
  }
  return e.prototype.process = function(t, n) {
    var i = this, a = {};
    return Object.keys(t).filter(function(u) {
      return i._allowedAttributeNames.includes(u);
    }).forEach(function(u) {
      return a[u] = t[u];
    }), a;
  }, e;
})(ve);
var un = new on(), cn = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, sn = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, ln = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, fn = (
  /** @class */
  function() {
    function r(e, t) {
      this._meterProviderSharedState = e, this._instrumentationScope = t, this.metricStorageRegistry = new Qr(), this.observableRegistry = new rn(), this.meter = new Hr(this);
    }
    return r.prototype.registerMetricStorage = function(e) {
      var t = this._registerMetricStorage(e, an);
      return t.length === 1 ? t[0] : new Kr(t);
    }, r.prototype.registerAsyncMetricStorage = function(e) {
      var t = this._registerMetricStorage(e, Xr);
      return t;
    }, r.prototype.collect = function(e, t, n) {
      return cn(this, void 0, void 0, function() {
        var i, a, u;
        return sn(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, this.observableRegistry.observe(t, n == null ? void 0 : n.timeoutMillis)];
            case 1:
              return i = c.sent(), a = this.metricStorageRegistry.getStorages(e), a.length === 0 ? [2, null] : (u = a.map(function(s) {
                return s.collect(e, t);
              }).filter(Gt), u.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: u
                },
                errors: i
              }]);
          }
        });
      });
    }, r.prototype._registerMetricStorage = function(e, t) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(e, this._instrumentationScope), a = i.map(function(s) {
        var o = Wt(s, e), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(o);
        if (l != null)
          return l;
        var f = s.aggregation.createAggregator(o), p = new t(o, f, s.attributesProcessor, n._meterProviderSharedState.metricCollectors, s.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(p), p;
      });
      if (a.length === 0) {
        var u = this._meterProviderSharedState.selectAggregations(e.type), c = u.map(function(s) {
          var o = ln(s, 2), l = o[0], f = o[1], p = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, e);
          if (p != null)
            return p;
          var w = f.createAggregator(e), bt = l.selectCardinalityLimit(e.type), we = new t(e, w, ve.Noop(), [l], bt);
          return n.metricStorageRegistry.registerForCollector(l, we), we;
        });
        a = a.concat(c);
      }
      return a;
    }, r;
  }()
), dn = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, hn = (
  /** @class */
  function() {
    function r(e) {
      this.resource = e, this.viewRegistry = new Nr(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return r.prototype.getMeterSharedState = function(e) {
      var t = Vt(e), n = this.meterSharedStates.get(t);
      return n == null && (n = new fn(this, e), this.meterSharedStates.set(t, n)), n;
    }, r.prototype.selectAggregations = function(e) {
      var t, n, i = [];
      try {
        for (var a = dn(this.metricCollectors), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i.push([c, c.selectAggregation(e)]);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return i;
    }, r;
  }()
), V = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, H = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, pn = function(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), i, a = [], u;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; ) a.push(i.value);
  } catch (c) {
    u = { error: c };
  } finally {
    try {
      i && !i.done && (t = n.return) && t.call(n);
    } finally {
      if (u) throw u.error;
    }
  }
  return a;
}, yn = function(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, i = e.length, a; n < i; n++)
    (a || !(n in e)) && (a || (a = Array.prototype.slice.call(e, 0, n)), a[n] = e[n]);
  return r.concat(a || Array.prototype.slice.call(e));
}, vn = (
  /** @class */
  function() {
    function r(e, t) {
      this._sharedState = e, this._metricReader = t;
    }
    return r.prototype.collect = function(e) {
      return V(this, void 0, void 0, function() {
        var t, n, i, a, u = this;
        return H(this, function(c) {
          switch (c.label) {
            case 0:
              return t = pe(Date.now()), n = [], i = [], a = Array.from(this._sharedState.meterSharedStates.values()).map(function(s) {
                return V(u, void 0, void 0, function() {
                  var o;
                  return H(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, s.collect(this, t, e)];
                      case 1:
                        return o = l.sent(), (o == null ? void 0 : o.scopeMetrics) != null && n.push(o.scopeMetrics), (o == null ? void 0 : o.errors) != null && i.push.apply(i, yn([], pn(o.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(a)];
            case 1:
              return c.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return V(this, void 0, void 0, function() {
        return H(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._metricReader.forceFlush(e)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.shutdown = function(e) {
      return V(this, void 0, void 0, function() {
        return H(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this._metricReader.shutdown(e)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.selectAggregationTemporality = function(e) {
      return this._metricReader.selectAggregationTemporality(e);
    }, r.prototype.selectAggregation = function(e) {
      return this._metricReader.selectAggregation(e);
    }, r.prototype.selectCardinalityLimit = function(e) {
      var t, n, i;
      return (i = (n = (t = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(t, e)) !== null && i !== void 0 ? i : 2e3;
    }, r;
  }()
), Ge = function(r, e, t, n) {
  function i(a) {
    return a instanceof t ? a : new t(function(u) {
      u(a);
    });
  }
  return new (t || (t = Promise))(function(a, u) {
    function c(l) {
      try {
        o(n.next(l));
      } catch (f) {
        u(f);
      }
    }
    function s(l) {
      try {
        o(n.throw(l));
      } catch (f) {
        u(f);
      }
    }
    function o(l) {
      l.done ? a(l.value) : i(l.value).then(c, s);
    }
    o((n = n.apply(r, e || [])).next());
  });
}, Ve = function(r, e) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, u;
  return u = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function c(o) {
    return function(l) {
      return s([o, l]);
    };
  }
  function s(o) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; t; ) try {
      if (n = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
      switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
        case 0:
        case 1:
          a = o;
          break;
        case 4:
          return t.label++, { value: o[1], done: !1 };
        case 5:
          t.label++, i = o[1], o = [0];
          continue;
        case 7:
          o = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (o[0] === 6 || o[0] === 2)) {
            t = 0;
            continue;
          }
          if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
            t.label = o[1];
            break;
          }
          if (o[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = o;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(o);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      o = e.call(r, t);
    } catch (l) {
      o = [6, l], i = 0;
    } finally {
      n = a = 0;
    }
    if (o[0] & 5) throw o[1];
    return { value: o[0] ? o[1] : void 0, done: !0 };
  }
}, He = function(r) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && r[e], n = 0;
  if (t) return t.call(r);
  if (r && typeof r.length == "number") return {
    next: function() {
      return r && n >= r.length && (r = void 0), { value: r && r[n++], done: !r };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function mn(r, e) {
  var t = e ?? Se.empty();
  return r ? Se.default().merge(t) : t;
}
var _n = (
  /** @class */
  function() {
    function r(e) {
      var t, n, i, a, u;
      if (this._shutdown = !1, this._sharedState = new hn(mn((u = e == null ? void 0 : e.mergeResourceWithDefaults) !== null && u !== void 0 ? u : !0, e == null ? void 0 : e.resource)), (e == null ? void 0 : e.views) != null && e.views.length > 0)
        try {
          for (var c = He(e.views), s = c.next(); !s.done; s = c.next()) {
            var o = s.value;
            this._sharedState.viewRegistry.addView(o);
          }
        } catch (w) {
          t = { error: w };
        } finally {
          try {
            s && !s.done && (n = c.return) && n.call(c);
          } finally {
            if (t) throw t.error;
          }
        }
      if ((e == null ? void 0 : e.readers) != null && e.readers.length > 0)
        try {
          for (var l = He(e.readers), f = l.next(); !f.done; f = l.next()) {
            var p = f.value;
            this.addMetricReader(p);
          }
        } catch (w) {
          i = { error: w };
        } finally {
          try {
            f && !f.done && (a = l.return) && a.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return r.prototype.getMeter = function(e, t, n) {
      return t === void 0 && (t = ""), n === void 0 && (n = {}), this._shutdown ? (h.warn("A shutdown MeterProvider cannot provide a Meter"), St()) : this._sharedState.getMeterSharedState({
        name: e,
        version: t,
        schemaUrl: n.schemaUrl
      }).meter;
    }, r.prototype.addMetricReader = function(e) {
      var t = new vn(this._sharedState, e);
      e.setMetricProducer(t), this._sharedState.metricCollectors.push(t);
    }, r.prototype.shutdown = function(e) {
      return Ge(this, void 0, void 0, function() {
        return Ve(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (h.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(e);
              }))]);
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r.prototype.forceFlush = function(e) {
      return Ge(this, void 0, void 0, function() {
        return Ve(this, function(t) {
          switch (t.label) {
            case 0:
              return this._shutdown ? (h.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(e);
              }))];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, r;
  }()
);
function gn(r, e) {
  var t = xt(e);
  return {
    resource: Ot(r.resource),
    schemaUrl: void 0,
    scopeMetrics: wn(r.scopeMetrics, t)
  };
}
function wn(r, e) {
  return Array.from(r.map(function(t) {
    return {
      scope: It(t.scope),
      metrics: t.metrics.map(function(n) {
        return bn(n, e);
      }),
      schemaUrl: t.scope.schemaUrl
    };
  }));
}
function bn(r, e) {
  var t = {
    name: r.descriptor.name,
    description: r.descriptor.description,
    unit: r.descriptor.unit
  }, n = En(r.aggregationTemporality);
  switch (r.dataPointType) {
    case m.SUM:
      t.sum = {
        aggregationTemporality: n,
        isMonotonic: r.isMonotonic,
        dataPoints: Fe(r, e)
      };
      break;
    case m.GAUGE:
      t.gauge = {
        dataPoints: Fe(r, e)
      };
      break;
    case m.HISTOGRAM:
      t.histogram = {
        aggregationTemporality: n,
        dataPoints: Tn(r, e)
      };
      break;
    case m.EXPONENTIAL_HISTOGRAM:
      t.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: Mn(r, e)
      };
      break;
  }
  return t;
}
function Sn(r, e, t) {
  var n = {
    attributes: ye(r.attributes),
    startTimeUnixNano: t.encodeHrTime(r.startTime),
    timeUnixNano: t.encodeHrTime(r.endTime)
  };
  switch (e) {
    case T.INT:
      n.asInt = r.value;
      break;
    case T.DOUBLE:
      n.asDouble = r.value;
      break;
  }
  return n;
}
function Fe(r, e) {
  return r.dataPoints.map(function(t) {
    return Sn(t, r.descriptor.valueType, e);
  });
}
function Tn(r, e) {
  return r.dataPoints.map(function(t) {
    var n = t.value;
    return {
      attributes: ye(t.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: e.encodeHrTime(t.startTime),
      timeUnixNano: e.encodeHrTime(t.endTime)
    };
  });
}
function Mn(r, e) {
  return r.dataPoints.map(function(t) {
    var n = t.value;
    return {
      attributes: ye(t.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: e.encodeHrTime(t.startTime),
      timeUnixNano: e.encodeHrTime(t.endTime)
    };
  });
}
function En(r) {
  switch (r) {
    case y.DELTA:
      return 1;
    case y.CUMULATIVE:
      return 2;
  }
}
function An(r, e) {
  return {
    resourceMetrics: r.map(function(t) {
      return gn(t, e);
    })
  };
}
var xn = {
  serializeRequest: function(r) {
    var e = An([r], {
      useLongBits: !1
    }), t = new TextEncoder();
    return t.encode(JSON.stringify(e));
  },
  deserializeResponse: function(r) {
    var e = new TextDecoder();
    return JSON.parse(e.decode(r));
  }
}, D;
(function(r) {
  r[r.DELTA = 0] = "DELTA", r[r.CUMULATIVE = 1] = "CUMULATIVE", r[r.LOWMEMORY = 2] = "LOWMEMORY";
})(D || (D = {}));
var On = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), de = function() {
  return y.CUMULATIVE;
}, dt = function(r) {
  switch (r) {
    case d.COUNTER:
    case d.OBSERVABLE_COUNTER:
    case d.GAUGE:
    case d.HISTOGRAM:
    case d.OBSERVABLE_GAUGE:
      return y.DELTA;
    case d.UP_DOWN_COUNTER:
    case d.OBSERVABLE_UP_DOWN_COUNTER:
      return y.CUMULATIVE;
  }
}, ht = function(r) {
  switch (r) {
    case d.COUNTER:
    case d.HISTOGRAM:
      return y.DELTA;
    case d.GAUGE:
    case d.UP_DOWN_COUNTER:
    case d.OBSERVABLE_UP_DOWN_COUNTER:
    case d.OBSERVABLE_COUNTER:
    case d.OBSERVABLE_GAUGE:
      return y.CUMULATIVE;
  }
};
function In() {
  var r = Rt(), e = r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return e === "cumulative" ? de : e === "delta" ? dt : e === "lowmemory" ? ht : (h.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + r.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), de);
}
function Cn(r) {
  return r != null ? r === D.DELTA ? dt : r === D.LOWMEMORY ? ht : de : In();
}
function Rn(r) {
  return r != null && r.aggregationPreference ? r.aggregationPreference : function(e) {
    return b.Default();
  };
}
var Nn = (
  /** @class */
  function(r) {
    On(e, r);
    function e(t, n) {
      var i = r.call(this, t) || this;
      return i._aggregationSelector = Rn(n), i._aggregationTemporalitySelector = Cn(n == null ? void 0 : n.temporalityPreference), i;
    }
    return e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e;
  }(Ct)
), Pn = /* @__PURE__ */ function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i) Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), kn = (
  /** @class */
  function(r) {
    Pn(e, r);
    function e(t) {
      return r.call(this, Nt(t ?? {}, xn, "v1/metrics", { "Content-Type": "application/json" }), t) || this;
    }
    return e;
  }(Nn)
);
const Ln = 1e4;
function Un({
  url: r,
  httpHeaders: e = {},
  exportIntervalsMillis: t = Ln,
  ...n
}) {
  const i = e ?? {}, a = new Rr({
    exporter: new kn({
      url: r,
      headers: i
    }),
    exportIntervalMillis: t
  }), u = Bn(n, [
    a
  ]);
  return Ye.setGlobalMeterProvider(u), u;
}
function Bn(r, e) {
  return new _n({
    resource: Pt(r),
    readers: e
  });
}
var he, pt = -1, I = function(r) {
  addEventListener("pageshow", function(e) {
    e.persisted && (pt = e.timeStamp, r(e));
  }, !0);
}, me = function() {
  var r = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (r && r.responseStart > 0 && r.responseStart < performance.now()) return r;
}, X = function() {
  var r = me();
  return r && r.activationStart || 0;
}, _ = function(r, e) {
  var t = me(), n = "navigate";
  return pt >= 0 ? n = "back-forward-cache" : t && (document.prerendering || X() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : t.type && (n = t.type.replace(/_/g, "-"))), { name: r, value: e === void 0 ? -1 : e, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, k = function(r, e, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(r)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          e(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: r, buffered: !0 }, t || {})), n;
    }
  } catch {
  }
}, g = function(r, e, t, n) {
  var i, a;
  return function(u) {
    e.value >= 0 && (u || n) && ((a = e.value - (i || 0)) || i === void 0) && (i = e.value, e.delta = a, e.rating = function(c, s) {
      return c > s[1] ? "poor" : c > s[0] ? "needs-improvement" : "good";
    }(e.value, t), r(e));
  };
}, _e = function(r) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return r();
    });
  });
}, q = function(r) {
  document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && r();
  });
}, ge = function(r) {
  var e = !1;
  return function() {
    e || (r(), e = !0);
  };
}, O = -1, je = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, z = function(r) {
  document.visibilityState === "hidden" && O > -1 && (O = r.type === "visibilitychange" ? r.timeStamp : 0, Gn());
}, De = function() {
  addEventListener("visibilitychange", z, !0), addEventListener("prerenderingchange", z, !0);
}, Gn = function() {
  removeEventListener("visibilitychange", z, !0), removeEventListener("prerenderingchange", z, !0);
}, yt = function() {
  return O < 0 && (O = je(), De(), I(function() {
    setTimeout(function() {
      O = je(), De();
    }, 0);
  })), { get firstHiddenTime() {
    return O;
  } };
}, Y = function(r) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return r();
  }, !0) : r();
}, ze = [1800, 3e3], vt = function(r, e) {
  e = e || {}, Y(function() {
    var t, n = yt(), i = _("FCP"), a = k("paint", function(u) {
      u.forEach(function(c) {
        c.name === "first-contentful-paint" && (a.disconnect(), c.startTime < n.firstHiddenTime && (i.value = Math.max(c.startTime - X(), 0), i.entries.push(c), t(!0)));
      });
    });
    a && (t = g(r, i, ze, e.reportAllChanges), I(function(u) {
      i = _("FCP"), t = g(r, i, ze, e.reportAllChanges), _e(function() {
        i.value = performance.now() - u.timeStamp, t(!0);
      });
    }));
  });
}, $e = [0.1, 0.25], Vn = function(r, e) {
  e = e || {}, vt(ge(function() {
    var t, n = _("CLS", 0), i = 0, a = [], u = function(s) {
      s.forEach(function(o) {
        if (!o.hadRecentInput) {
          var l = a[0], f = a[a.length - 1];
          i && o.startTime - f.startTime < 1e3 && o.startTime - l.startTime < 5e3 ? (i += o.value, a.push(o)) : (i = o.value, a = [o]);
        }
      }), i > n.value && (n.value = i, n.entries = a, t());
    }, c = k("layout-shift", u);
    c && (t = g(r, n, $e, e.reportAllChanges), q(function() {
      u(c.takeRecords()), t(!0);
    }), I(function() {
      i = 0, n = _("CLS", 0), t = g(r, n, $e, e.reportAllChanges), _e(function() {
        return t();
      });
    }), setTimeout(t, 0));
  }));
}, mt = 0, ue = 1 / 0, F = 0, Hn = function(r) {
  r.forEach(function(e) {
    e.interactionId && (ue = Math.min(ue, e.interactionId), F = Math.max(F, e.interactionId), mt = F ? (F - ue) / 7 + 1 : 0);
  });
}, _t = function() {
  return he ? mt : performance.interactionCount || 0;
}, Fn = function() {
  "interactionCount" in performance || he || (he = k("event", Hn, { type: "event", buffered: !0, durationThreshold: 0 }));
}, v = [], j = /* @__PURE__ */ new Map(), gt = 0, jn = function() {
  var r = Math.min(v.length - 1, Math.floor((_t() - gt) / 50));
  return v[r];
}, Dn = [], zn = function(r) {
  if (Dn.forEach(function(i) {
    return i(r);
  }), r.interactionId || r.entryType === "first-input") {
    var e = v[v.length - 1], t = j.get(r.interactionId);
    if (t || v.length < 10 || r.duration > e.latency) {
      if (t) r.duration > t.latency ? (t.entries = [r], t.latency = r.duration) : r.duration === t.latency && r.startTime === t.entries[0].startTime && t.entries.push(r);
      else {
        var n = { id: r.interactionId, latency: r.duration, entries: [r] };
        j.set(n.id, n), v.push(n);
      }
      v.sort(function(i, a) {
        return a.latency - i.latency;
      }), v.length > 10 && v.splice(10).forEach(function(i) {
        return j.delete(i.id);
      });
    }
  }
}, wt = function(r) {
  var e = self.requestIdleCallback || self.setTimeout, t = -1;
  return r = ge(r), document.visibilityState === "hidden" ? r() : (t = e(r), q(r)), t;
}, We = [200, 500], $n = function(r, e) {
  "PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype && (e = e || {}, Y(function() {
    var t;
    Fn();
    var n, i = _("INP"), a = function(c) {
      wt(function() {
        c.forEach(zn);
        var s = jn();
        s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
      });
    }, u = k("event", a, { durationThreshold: (t = e.durationThreshold) !== null && t !== void 0 ? t : 40 });
    n = g(r, i, We, e.reportAllChanges), u && (u.observe({ type: "first-input", buffered: !0 }), q(function() {
      a(u.takeRecords()), n(!0);
    }), I(function() {
      gt = _t(), v.length = 0, j.clear(), i = _("INP"), n = g(r, i, We, e.reportAllChanges);
    }));
  }));
}, Xe = [2500, 4e3], ce = {}, Wn = function(r, e) {
  e = e || {}, Y(function() {
    var t, n = yt(), i = _("LCP"), a = function(s) {
      e.reportAllChanges || (s = s.slice(-1)), s.forEach(function(o) {
        o.startTime < n.firstHiddenTime && (i.value = Math.max(o.startTime - X(), 0), i.entries = [o], t());
      });
    }, u = k("largest-contentful-paint", a);
    if (u) {
      t = g(r, i, Xe, e.reportAllChanges);
      var c = ge(function() {
        ce[i.id] || (a(u.takeRecords()), u.disconnect(), ce[i.id] = !0, t(!0));
      });
      ["keydown", "click"].forEach(function(s) {
        addEventListener(s, function() {
          return wt(c);
        }, { once: !0, capture: !0 });
      }), q(c), I(function(s) {
        i = _("LCP"), t = g(r, i, Xe, e.reportAllChanges), _e(function() {
          i.value = performance.now() - s.timeStamp, ce[i.id] = !0, t(!0);
        });
      });
    }
  });
}, qe = [800, 1800], Xn = function r(e) {
  document.prerendering ? Y(function() {
    return r(e);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return r(e);
  }, !0) : setTimeout(e, 0);
}, qn = function(r, e) {
  e = e || {};
  var t = _("TTFB"), n = g(r, t, qe, e.reportAllChanges);
  Xn(function() {
    var i = me();
    i && (t.value = Math.max(i.responseStart - X(), 0), t.entries = [i], n(!0), I(function() {
      t = _("TTFB", 0), (n = g(r, t, qe, e.reportAllChanges))(!0);
    }));
  });
};
function Qn(r) {
  r.devMode || (Un(r), Yn());
}
function Yn() {
  const r = Ye.getMeter("web-vitals");
  Vn(R(r)), qn(R(r)), Wn(R(r)), $n(R(r)), vt(R(r));
}
function R(r) {
  const e = r.createObservableGauge("lcp"), t = r.createObservableGauge("cls"), n = r.createObservableGauge("fid"), i = r.createObservableGauge("ttfb"), a = r.createObservableGauge("fcp");
  return function(c) {
    switch (c.name) {
      case "LCP": {
        e.addCallback((s) => {
          s.observe(c.value);
        });
        break;
      }
      case "CLS": {
        t.addCallback((s) => {
          s.observe(c.value);
        });
        break;
      }
      case "FID": {
        n.addCallback((s) => {
          s.observe(c.value);
        });
        break;
      }
      case "TTFB": {
        i.addCallback((s) => {
          s.observe(c.value);
        });
        break;
      }
      case "FCP": {
        a.addCallback((s) => {
          s.observe(c.value);
        });
        break;
      }
      default:
        console.log("unexpected metric name");
    }
  };
}
export {
  Un as createMetricsProvider,
  Bn as getMetricsProviderInstance,
  Ye as metrics,
  Qn as setupWebVitalsReporting
};
